import { z } from 'zod'
import { ServiceStatus } from '~/enums/service-status'

/**
 * 問題答覆 - 查詢多筆 Request Schema
 */
export const serviceIssueListDataSchema = z.object({
  /** 技術服務問題ID */
  siID: z.number(),
  /** 產品主類目(中) */
  pmNameZh: z.string(),
  /** 產品主類目(英) */
  pmNameEn: z.string(),
  /** 問題分類(中) */
  serviceClassZh: z.string().nullable(),
  /** 問題分類(英) */
  serviceClassEn: z.string().nullable(),
  /** 提問時間 */
  createDate: z.string(),
  /** 提問人 */
  whoAsk: z.string(),
  /** 問題標題 */
  topic: z.string(),
  /** 問題內容 */
  content: z.string(),
  /** 答覆人員 */
  reply: z.string().nullable(),
  /** 答覆時間 */
  replyDate: z.string().nullable(),
  /** 狀態 */
  serviceStatus: z.nativeEnum(ServiceStatus),
  /** 問題狀態底色 */
  serviceStatusColor: z.string(),
  /** 問題狀態(中) */
  serviceStatusZh: z.string(),
  /** 問題狀態(英) */
  serviceStatusEn: z.string(),
  /** 問題層級 */
  serviceUrgent: z.string().nullable()
})

/**
 * 問題答覆 - 查詢多筆 Request
 */
export interface ServiceIssueListData
  extends z.infer<typeof serviceIssueListDataSchema> {}
